import api from './axiosConfig';
const url = '/api/mecanica';

export const obtenerRevisiones = async () => {
  try {
    const response = await api.get(
      url+'/ver/revision-vehiculo', 
      { withCredentials: true }
    );
    return response.data.informes || [];
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const obtenerRevision = async (numeroOT) => {
  try {
    const response = await api.get(url+`/ver/revision-vehiculo/${numeroOT}`, {
      withCredentials: true,
    });

    if ( response.data.ok  ){
      return response.data.informe || [];
    }

  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const agregarRevisionVehiculo = async (data) => {
  try {
    const response = await api.post(url+'/agregar/revision-vehiculo', data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const actualizarRevision = async (numeroOT, data) => {
  try {
    const response = await api.put(url+`/editar/revision-vehiculo/${numeroOT}`, data, {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const enviarRevision = async (numeroOT, formData) => {
  try {
    const response = await api.post(
      url+`/enviar/revision-vehiculo/${numeroOT}`, 
      formData, { withCredentials: true });

    return { status: response.status, ...response.data };

  } catch (error) {
    throw error.response?.data.msg || error;
  }
};


// ------------------ CATALOGO ------------------

export const obtenerMecanicos = async () => {
  try {
    const response = await api.get(
      url+'/ver/mecanicos', {
      withCredentials: true,
    });
    return response.data.mecanicos || [];
  } catch (error) {
    throw error.response?.data.msg || error;
  }
}

export const obtenerTecnicos = async () => {
  try {
    const response = await api.get(
      url+'/ver/tecnicos', {
      withCredentials: true,
    });
    return response.data.tecnicos || [];
  } catch (error) {
    throw error.response?.data.msg || error;
  }
}

export const obtenerServicios = async (id_empresa) => {
  try {
    const response = await api.get(
      url+`/ver/servicios/${id_empresa}`, {
      withCredentials: true,
    });
    return response.data.servicios || [];
  } catch (error) {
    throw error.response?.data.msg || error;
  }
}

export const obtenerPartesVehiculo = async () => {
  try {
    const response = await api.get(
      url+'/ver/listado-partes-vehiculo', {
      withCredentials: true,
    });
    return response.data.partes || [];
  } catch (error) {
    throw error.response?.data.msg || error;
  }
}










export const historicoVehicular = async (patente) => {
  try {
    const response = await api.get(
      url+`/ver/historico-vehiculo/${patente}`, {withCredentials: true }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 403) {
      return { data: [], status: 403, message: error.response.data.msg  };
    } else {
      throw error.response?.data.msg || error;
    }
  }
}